import { useEffect, useState } from 'react';
import { account } from '../../appwrite/config';
import { useNavigate } from 'react-router-dom';

function TopHeaders() {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [showHideHeaderUser, setshowHideHeaderUser] = useState(false);
    const [userData, setuserData] = useState(null);

    useEffect(() => {

        //refresh token
        const refreshJWT = async () => {
            try {
                const jwtResponse = await account.createJWT();
                sessionStorage.setItem('JWT_TOKEN', jwtResponse.jwt);
            } catch (error) {
                console.error('Failed to refresh JWT:', error);
            }
        };

        // Refresh JWT every 10 minutes (600,000 ms)
        const interval = setInterval(refreshJWT, 10 * 60 * 1000);

        // Initial fetch on mount
        refreshJWT();

        checkSession();
        return () => clearInterval(interval);
    }, []);

    const checkSession = async () => {
        try {
            const getUserData = await account.get();
            setIsLoggedIn(true);
            setuserData(getUserData);
        } catch {
            setIsLoggedIn(false);
        }
    };


    const handleLogout = async () => {
        await account.deleteSession('current');        
        navigate('/');
        window.location.reload();

    };

    const toggleSidebar = () => {
        setSidebarOpen((prev) => !prev);
        document.documentElement.className = sidebarOpen ? "aside-mobile-expanded" : "";
    };

    const showHideUserDD = () => {
        setshowHideHeaderUser((prev) => !prev);
        //document.documentElement.className = sidebarOpen ? "aside-mobile-expanded" : "";
    };

    const fullName = userData?.name || "Jhon Doe";
    const avtaar = `https://api.dicebear.com/10.x/initials/svg?seed=${encodeURIComponent(fullName)}`;
    return (

        <nav id="navbar-main" className="navbar is-fixed-top">
            <div className="navbar-brand">
                <button type="button" className="navbar-item mobile-aside-button" onClick={toggleSidebar} aria-label="Toggle sidebar">
                    <span className="icon"><i className={`mdi mdi-24px ${sidebarOpen ? "mdi-forwardburger" : "mdi-backburger"}`}></i></span>
                </button>
            </div>
            <div className="navbar-brand is-right">
                <button type="button" className="navbar-item --jb-navbar-menu-toggle" data-target="navbar-menu" onClick={showHideUserDD} aria-label="Toggle user menu">
                    <span className="icon"><i className={`mdi mdi-24px ${showHideHeaderUser ? "mdi-close" : "mdi-dots-vertical"}`}></i></span>
                </button>
            </div>
            <div className={`navbar-menu ${showHideHeaderUser ? "active" : ""}`}>
                <div className="navbar-end">
                    <div className={`navbar-item dropdown has-divider has-user-avatar ${showHideHeaderUser ? "active" : ""}`}>
                        <button type="button" className="navbar-link" onClick={showHideUserDD}>
                            <div className="user-avatar">
                                <img src={avtaar} alt={isLoggedIn ? userData?.name : ''} className="rounded-full" />
                            </div>
                            <div className="is-user-name"><span>{isLoggedIn ? userData?.name : ''}</span></div>
                            <span className="icon"><i className="mdi mdi-chevron-down"></i></span>
                        </button>
                        <div className="navbar-dropdown">
                            {/* <a href="profile.html" className="navbar-item">
                                <span className="icon"><i className="mdi mdi-account"></i></span>
                                <span>My Profile</span>
                            </a>
                            <a className="navbar-item">
                                <span className="icon"><i className="mdi mdi-settings"></i></span>
                                <span>Settings</span>
                            </a>
                            <a className="navbar-item">
                                <span className="icon"><i className="mdi mdi-email"></i></span>
                                <span>Messages</span>
                            </a> */}
                            <hr className="navbar-divider" />
                            <button type="button" className="navbar-item" onClick={handleLogout}>
                                <span className="icon"><i className="mdi mdi-logout"></i></span>
                                <span>Log Out</span>
                            </button>
                        </div>
                    </div>


                    {/* <a href="#" title="Log out" className="navbar-item desktop-icon-only" onClick={handleLogout}>
                        <span className="icon"><i className="mdi mdi-logout"></i></span>
                        <span>Log out</span>
                    </a> */}
                </div>
            </div>
        </nav>
    );
}


export default TopHeaders;
